import React, { ReactNode } from 'react';
import { SAPContact } from '../../types';
import { SapContactCard } from './SapContactCard';
import styles from './SapContact.module.css';

interface SapContactListSectionProps {
  headerIcon: ReactNode;
  headerLabel: string;
  contacts: SAPContact[];
  isLoading: boolean;
  error?: string | null;
  emptyMessage: string;
  loadingMessage: string;
  callerNumber?: string | null;
  linkedSapContactId?: string | null;
  showActions: (contactCount: number) => boolean;
  onLink: (contact: SAPContact) => void;
}

export function SapContactListSection({
  headerIcon,
  headerLabel,
  contacts,
  isLoading,
  error,
  emptyMessage,
  loadingMessage,
  callerNumber,
  linkedSapContactId,
  showActions,
  onLink,
}: SapContactListSectionProps) {
  const shouldShowActions = showActions(contacts.length);

  return (
    <div className={styles.sapContactSection}>
      <div className={styles.sapContactHeader}>
        {headerIcon}
        <span>{headerLabel}</span>
      </div>

      {isLoading && (
        <div className={styles.sapContactLoading}>
          <div className={styles.miniSpinner} />
          <span>{loadingMessage}</span>
        </div>
      )}

      {!isLoading && contacts.length > 0 && (
        <div className={styles.sapContactMatches}>
          <div className={styles.sapContactList}>
            {contacts.map((contact) => (
              <SapContactCard
                key={contact.id}
                contact={contact}
                callerNumber={callerNumber}
                linkedSapContactId={linkedSapContactId}
                showActions={shouldShowActions}
                onLink={onLink}
              />
            ))}
          </div>
        </div>
      )}

      {!isLoading && contacts.length === 0 && !error && (
        <div className={styles.sapContactEmpty}>{emptyMessage}</div>
      )}

      {error && <div className={styles.sapContactError}>{error}</div>}
    </div>
  );
}
